"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./game-flyweb"));
__export(require("./game-local-2p"));
__export(require("./game-local-ai"));

//# sourceMappingURL=index.js.map
